import React, { useEffect } from 'react';
import { FormType } from '../../types/form.types';
import ContactFormPageContent from './contact-form-page.content';
import useGetFormFields from '../../network/hooks/get-form-fields.hook';
import useQueryParams from '../../hooks/use-query-params.hook';
import { useParamsContext } from '../../params/params-context';

interface ContactFormProps {
  type: FormType;
}

const ContactFormPage: React.FunctionComponent<ContactFormProps> = ({
  type
}) => {
  const getFormFields = useGetFormFields(type);

  const headerType = type === 'partner_prospects' ? 'partner' : 'support';
  const { question } = useQueryParams();
  const { pages } = useParamsContext();

  if (
    type !== 'partner_prospects' &&
    !question &&
    pages &&
    pages.faq &&
    /^http/.test(pages.faq)
  ) {
    window.location.replace(pages.faq);
  }

  useEffect(() => {
    getFormFields?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ContactFormPageContent headerType={headerType} type={type} />;
};

export default ContactFormPage;
